import React from 'react'
import Itinerary from '../../components/Itinerary'

function ItinearyPage() {
  return (
    <Itinerary/>
  )
}

export default ItinearyPage